<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 19 16"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22.558661,21.0216326 L32.458156,11.1221377 L22.558661,1.22264277 M1,11.1221377 L32.458156,11.1221377" :stroke="fill" stroke-width="2"></path>
    </g> -->
		<g id="icon-arrow-long" transform="translate(-1.000000, -8.000000)" :fill="fill" fill-rule="nonzero">
				<path  d="M12.5646202,8.43234738 L12.6588275,8.51553598 L19.5583225,15.4150309 C19.5867597,15.4434682 19.6134922,15.4736102 19.6383535,15.5052905 L19.5583225,15.4150309 C19.5963934,15.4531018 19.6307529,15.4934787 19.661401,15.535712 L19.7297896,15.6439843 L19.7691525,15.724748 L19.8153705,15.8561447 L19.8310505,15.9213436 L19.844419,16.0049932 L19.8512157,16.1221377 C19.8512157,16.172758 19.8474545,16.2224998 19.8401963,16.2710989 L19.8154947,16.3879773 L19.7817269,16.4891305 L19.7560235,16.5485973 L19.7052758,16.6427555 L19.6315269,16.7475867 L19.5583225,16.8292445 L12.6588275,23.7287394 C12.2683032,24.1192637 11.6351383,24.1192637 11.244614,23.7287394 C10.88413,23.3682555 10.8564005,22.8010244 11.1614254,22.4087332 L11.244614,22.3145259 L16.437,17.122 L2.39305972,17.1221377 C1.84077497,17.1221377 1.39305972,16.6744225 1.39305972,16.1221377 C1.39305972,15.6093019 1.77909991,15.1866305 2.2764386,15.1288654 L2.39305972,15.1221377 L16.437,15.122 L11.244614,9.92974955 C10.88413,9.56926559 10.8564005,9.00203453 11.1614254,8.60974332 L11.244614,8.51553598 C11.5750576,8.18509235 12.0792262,8.13425487 12.4631237,8.36302354 L12.5646202,8.43234738 Z"></path>
		</g>
  </svg>
</template>

<script>
export default {
  props: {
		type: {
			type: String,
			ddefault: ''
		},
    width: {
      type: Number,
      default: 19,
    },
    height: {
      type: Number,
      default: 16,
    },
    fill: {
      type: String,
      default: "#FF3D37",
    },
  },
};
</script>

<style scoped>
path {
	transition: all .3s;
}
</style>
